import { render, staticRenderFns } from "./BudgetRecipientDialog.vue?vue&type=template&id=53204dce"
import script from "./BudgetRecipientDialog.vue?vue&type=script&lang=js"
export * from "./BudgetRecipientDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports